export const COLOR_DIMMED_DISCONNECTED = "#6b6a6a";
export const COLOR_DIMMED_DISCONNECTED_HOVER = "#525151";
export const COLOR_GOLDEN_SHADOW = "#eee09a7a";
export const COLOR_LIGHTEST_GREY = "#cccccc";
export const COLOR_LIGHT_NAVY = "#1f4068";
export const COLOR_LIGHTER_NAVY = "#2a5585";
